import React, { createContext, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import hipersendService from '../../services/hipersend'

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [queryParameters] = useSearchParams()

  const logout = () => {
    window.localStorage.setItem('api', '')
    window.localStorage.setItem('secret', '')
    window.location.replace('/signin')
  }

  const signin = async (api, secret) => {
    try {
      await hipersendService.notificacoesInteligentes.getInformations(api, secret)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const resetLocalStorageCredentials = () => {
    window.localStorage.setItem('api', '')
    window.localStorage.setItem('secret', '')
  }

  const handleIsLoggedIn = () => {
    const queryApi = queryParameters.get('api')
    const querySecret = queryParameters.get('secret')
    const api = queryApi || window.localStorage.getItem('api')
    const secret = querySecret || window.localStorage.getItem('secret')

    const isSigninPage = window.location.pathname === '/signin'

    if((!api || !secret) && !isSigninPage) {
      logout()
      return
    }

    if(queryApi || querySecret) {
      resetLocalStorageCredentials()
      return
    }

    window.localStorage.setItem('api', api)
    window.localStorage.setItem('secret', secret)
  }

  useEffect(() => {
    handleIsLoggedIn()
  }, [])

  return (
    <AuthContext.Provider value={{ logout, signin }}>
      {children}
    </AuthContext.Provider>
  )
}
